import React, { createContext, useContext } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { desktop } from '../../styles';

import Icon from './Icon';
import OneSizeCheckboxes from './OneSizeCheckboxes';
import SizeSelection from './SizeSelection';

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px ${({ theme }) => theme.spacing.small}px;
`;

const LargeText = styled.div`
  color: ${props => props.theme.colors.default};
  font-size: 28px;
  line-height: 34px;
  text-align: center;
`;

const SmallText = styled.div`
  color: ${props => props.theme.colors.default};
  font-size: 12px;
  text-align: center;
  letter-spacing: 1.75px;
  line-height: 14px;
  margin: 0px 13px;
  text-transform: uppercase;
`;

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.lavender100};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  cursor: default;
`;

const IconWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.moderate}px;
`;

const SelectWrapper = styled.div`
  width: 100%;
  ${desktop`
    width: 40%;
  `}
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  flex: 1;

  & > * {
    margin: 4px;
  }
`;

const SizeInputContext = createContext();
const SizeInputProvider = ({ children, value }) => {
  return (
    <SizeInputContext.Provider value={value}>
      {children}
    </SizeInputContext.Provider>
  );
};

export const useSizeInputContext = () => {
  return useContext(SizeInputContext);
};

const SizeInput = ({
  bandSizeList,
  children,
  className,
  cupSizeList,
  name,
  onChange = () => {},
  value,
  options,
}) => {
  return (
    <SizeInputProvider
      value={{
        bandSizeList,
        cupSizeList,
        name,
        onChange,
        value,
        options,
      }}
    >
      <Wrapper className={className}>{children}</Wrapper>
    </SizeInputProvider>
  );
};

SizeInput.propTypes = {
  bandSizeList: PropTypes.array,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  cupSizeList: PropTypes.array,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  options: PropTypes.array,
};

SizeInput.Icon = Icon;
SizeInput.IconWrapper = IconWrapper;
SizeInput.LargeText = LargeText;
SizeInput.OneSizeCheckboxes = OneSizeCheckboxes;
SizeInput.SelectWrapper = SelectWrapper;
SizeInput.SizeSelection = SizeSelection;
SizeInput.SmallText = SmallText;
SizeInput.TextWrapper = TextWrapper;

export default SizeInput;
